/**
 * Spanish (Español) Language File
 * 
 * This file contains all Spanish translations for the application.
 */

export const es = {
  // Language info
  language: {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸',
  },

  // Common/General translations
  common: {
    welcome: 'Bienvenidos',
    back: 'Volver',
    backTo: 'Volver a',
    next: 'Siguiente',
    previous: 'Anterior',
    continue: 'Continuar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    close: 'Cerrar',
    loading: 'Cargando',
    error: 'Error',
    success: 'Éxito',
    warning: 'Advertencia',
    info: 'Información',
    yes: 'Sí',
    no: 'No',
    ok: 'OK',
    placeholderNote: '⚠️ Contenido placeholder — pendiente de definir por el equipo de Fe en Juego.',
  },

  // Home Page
  home: {
    title: 'Bienvenidos',
    subtitle: 'Diversión, desafíos y Biblia en cada partida.',
    chooseGame: 'Elige un juego',
    heroSubtitle: 'Juegos interactivos que fortalecen la fe y conectan comunidades',
    exploreGames: 'Explorar Juegos',
    ourGames: 'Nuestros Juegos',
    conectadosDescription: 'Explora categorías de Sabiduría y Alianza con preguntas diseñadas para profundizar tu conocimiento.',
    playGame: 'Jugar',
    followUs: 'Conectate con nosotros',
    copyright: '© 2025 Fe en Juego. Todos los derechos reservados.',
  },

  // Games Catalog
  games: {
    status: {
      available: 'Disponible',
      preSale: 'Pre-venta',
      comingSoon: 'Próximamente',
    },
    actions: {
      buy: 'Comprar',
      preOrder: 'Pre-ordenar',
      playNow: 'Jugar ahora',
      howToPlay: 'Cómo jugar',
      comingSoon: 'Próximamente',
    },
    conecta2: {
      name: 'Conecta2',
      subtitle: 'Juego de preguntas y respuestas',
      description: 'Explora categorías de Sabiduría y Alianza con preguntas diseñadas para profundizar tu conocimiento.',
    },
    bibliquien: {
      name: 'BibliQuien?',
      subtitle: 'Juego de descarte y personajes bíblicos',
      description: 'Hacé las preguntas correctas, descartá bien y descubrí el personaje bíblico secreto de tu oponente.',
    },
    logoYa: {
      name: 'Logo YA!',
      subtitle: 'Desafío de velocidad visual',
      description: 'Identifica rápidamente símbolos y conceptos de la fe en un emocionante juego de agilidad mental.',
    },
  },

  // Resources Section
  resources: {
    title: 'Recursos para Culto Joven',
    subtitle: 'Materiales y recursos descargables para líderes y equipos',
    download: 'Descargar',
    downloadLabel: 'Descargar',
    comingSoon: 'Próximamente',

    // Placeholder resources
    placeholders: {
      guides: {
        title: 'Guías de Juego',
        description: 'Instrucciones completas y guías paso a paso para facilitar el juego en tu grupo.',
      },
      presentations: {
        title: 'Presentaciones PPT',
        description: 'Presentaciones listas para usar en tus reuniones y actividades grupales.',
      },
      additionalMaterial: {
        title: 'Material Adicional',
        description: 'PDFs, hojas de trabajo y otros recursos complementarios para enriquecer la experiencia.',
      },
    },
  },

  // Links of Interest Section
  links: {
    title: 'Enlaces de Interés',
    subtitle: 'Recursos y sitios web útiles para la comunidad adventista',
    visit: 'Visitar',
    visitLabel: 'Visitar sitio web',

    // Individual links
    items: {
      iasd: {
        title: 'Página IASD',
        description: 'Sitio oficial de la Iglesia Adventista del Séptimo Día',
      },
      noticiasIasd: {
        title: 'Noticias IASD',
        description: 'Portal de noticias adventistas',
      },
      whatsappUu: {
        title: 'Canal WhatsApp UU',
        description: 'Canal oficial de WhatsApp Unión Uruguaya',
      },
      feliz7play: {
        title: 'Feliz7Play',
        description: 'Plataforma de contenido audiovisual adventista',
      },
      videosIasd: {
        title: 'Videos IASD',
        description: 'Canal oficial de YouTube de IASD Sudamérica',
      },
      radioNt: {
        title: 'Nuevo Tiempo UY',
        description: 'Radio Nuevo Tiempo Uruguay en vivo',
      },
      materialesIasd: {
        title: 'Materiales IASD',
        description: 'Centro de descargas de materiales adventistas',
      },
      paraElSabado: {
        title: 'Para el Sábado',
        description: 'Materiales especiales para tus actividades sabáticas',
      },
      galeriaImagenes: {
        title: 'Galería de Imágenes',
        description: 'Galería de imágenes cristianas para uso ministerial',
      },
      leccionJovenes: {
        title: 'Lección Jóvenes',
        description: 'Lecciones y materiales para clases de jóvenes',
      },
      jaMateriales: {
        title: 'Materiales JA',
        description: 'Materiales e información para Jóvenes Adventistas',
      },
      accionJoven: {
        title: 'Revista Acción Joven',
        description: 'Revista trimestral para jóvenes adventistas',
      },
      conquistadores: {
        title: 'Conquistadores',
        description: 'Materiales e información del club de Conquistadores',
      },
      ministerioNino: {
        title: 'Ministerio del Niño',
        description: 'Recursos para el ministerio infantil',
      },
      recursosBiblicos: {
        title: 'Recursos Bíblicos',
        description: 'Materiales y recursos para el estudio de la Biblia',
      },
      meditaciones2025: {
        title: 'Meditaciones 2025',
        description: 'Meditaciones para la puesta de sol 2025',
      },
      seme: {
        title: '7me',
        description: 'Aplicación oficial para miembros y amigos Adventistas',
      },
      probadVed: {
        title: 'Probad y Ved',
        description: 'Videos sobre mayordomía cristiana',
      },
    },
  },

  // Footer
  footer: {
    copyright: '© 2026 Fe en Juego. Todos los derechos reservados.',
  },

  // Conecta2 Game
  conectados: {
    // Main page
    title: 'Conecta2',
    playing: 'Estás jugando',
    subtitle: 'Juego de preguntas y respuestas',
    selectCategory: 'Selecciona una categoría',

    // Access control
    access: {
      title: 'Acceso a Conecta2',
      message: 'Ingresá el código que viene con tu juego.',
      placeholder: 'XXXXXX',
      submit: 'Acceder',
      invalidCode: 'Código de acceso incorrecto. Por favor, verifica el código en las instrucciones del juego.',
      emptyCode: 'Por favor, ingresa un código de acceso.',
      success: '¡Acceso concedido! Redirigiendo...',
      infoTitle: '¿Dónde encuentro el código?',
      infoText: 'El código de acceso se encuentra en las instrucciones incluidas en el juego.',
    },

    // Game controls
    startGame: 'Iniciar Juego',
    endGame: 'Finalizar Partida',
    resetGame: 'Reiniciar Juego',
    newGame: 'Nuevo Juego',

    // Categories
    categories: {
      sabiduria: {
        title: 'Sabiduría',
        description: 'Pon a prueba tu conocimiento en diferentes áreas',
        alt: 'Sabiduría - Pon a prueba tu conocimiento de lugares, variedades y personajes',
      },
      alianza: {
        title: 'Alianza',
        description: 'Explora el pacto, la unidad y la valentía',
        alt: 'Alianza - Explora temas de pacto, unidad y valentía',
      },
    },

    // Subcategories
    subcategories: {
      // Sabiduria
      lugares: {
        title: 'Lugares',
        description: 'Lugares y ubicaciones bíblicas',
      },
      variedades: {
        title: 'Variedades',
        description: 'Diferentes aspectos de la fe',
      },
      personajes: {
        title: 'Personajes',
        description: 'Personajes y figuras bíblicas',
      },

      // Alianza
      'si-nosotros': {
        title: 'Si Nosotros',
        description: 'Nuestro papel en el pacto de Dios',
      },
      coincidimos: {
        title: 'Coincidimos',
        description: 'Encontrar puntos en común en la fe',
      },
      arriesgamos: {
        title: 'Arriesgamos',
        description: 'Tomar riesgos por nuestras creencias',
      },
    },

    // Question page
    question: {
      title: 'Pregunta',
      question: 'Pregunta',
      prompt: 'Consigna',
      answer: 'Respuesta',
      options: 'Opciones de respuesta:',
      whichVerse: '¿Qué versículo utilizarías?',
      reference: 'Referencia bíblica:',
      showAnswer: 'Mostrar Respuesta',
      hideAnswer: 'Ocultar Respuesta',
      endTurn: 'Terminar Turno',
      nextQuestion: 'Siguiente Pregunta',
      loading: 'Cargando pregunta...',
      noQuestions: 'No hay más preguntas disponibles',
      error: 'Error al cargar preguntas',
      tryAgain: 'Intentar de Nuevo',
      trueOption: 'Verdadero',
      falseOption: 'Falso',
    },

    // Stats
    stats: {
      questionsAnswered: 'Preguntas respondidas:',
      totalQuestions: 'Total de preguntas:',
      questionsRemaining: 'Preguntas restantes:',
      resetQuestions: 'Reiniciar Preguntas',
      categoryStats: 'Estadísticas de esta subcategoría',
    },

    // Completion
    completion: {
      congratulations: '¡Felicitaciones!',
      allQuestionsCompleted: '¡Has respondido todas las preguntas de esta categoría!',
      questionsCompleted: 'Preguntas completadas:',
      returnToConectados: 'Volver a Conecta2',
      returnToCategories: 'Volver a Categorías',
    },

    // Footer
    footer: {
      quote: '"Es mejor ser dos que uno, porque ambos pueden ayudarse mutuamente a lograr el éxito."',
      reference: 'Eclesiastés 4:9 (NTV)',
    },

    // PDF Modal (How to Play)
    pdfModal: {
      title: 'Cómo Jugar',
      mobileTitle: 'Ver Instrucciones PDF',
      mobileDescription: 'Para una mejor experiencia en dispositivos móviles, puedes abrir el PDF en una nueva pestaña o descargarlo.',
      openPDF: 'Abrir PDF',
      downloadPDF: 'Descargar PDF',
    },
  },

  // Error messages
  errors: {
    general: 'Ha ocurrido un error',
    notFound: 'No encontrado',
    categoryNotFound: 'Categoría no encontrada',
    subcategoryNotFound: 'Subcategoría no encontrada',
    questionsNotFound: 'No se encontraron preguntas',
    loadingFailed: 'Error al cargar',
    networkError: 'Error de conexión',
  },

  // Success messages
  success: {
    saved: 'Guardado exitosamente',
    deleted: 'Eliminado exitosamente',
    updated: 'Actualizado exitosamente',
  },

  // Time and dates
  time: {
    seconds: 'segundos',
    minutes: 'minutos',
    hours: 'horas',
    days: 'días',
    weeks: 'semanas',
    months: 'meses',
    years: 'años',
  },

  // Accessibility
  a11y: {
    menu: 'Menú',
    close: 'Cerrar',
    open: 'Abrir',
    previous: 'Anterior',
    next: 'Siguiente',
    loading: 'Cargando',
  },

  // Thank You / Payment Confirmation Page
  gracias: {
    // Success state
    success: {
      title: '¡Gracias por tu compra!',
      message: 'Tu pago fue recibido correctamente. Envianos el comprobante por WhatsApp junto con:',
      info1: 'Nombre completo',
      info2: 'Dirección',
      info3: 'Teléfono',
      info4: 'Forma de entrega (retiro o envío)',
      paymentCode: 'Código de pago:',
      whatsappButton: 'Enviar por WhatsApp',
    },

    // Pending state
    pending: {
      title: 'Tu pago está pendiente',
      message: 'Mercado Pago está revisando tu transacción.',
      submessage: 'Avisanos por WhatsApp cuando se confirme el pago.',
      paymentCode: 'Código de transacción:',
    },

    // Failure state
    failure: {
      title: 'El pago no se pudo completar',
      message: 'Hubo un problema procesando tu compra.',
      submessage: 'Podés intentar nuevamente o contactarnos por WhatsApp si necesitás ayuda.',
      retryButton: 'Reintentar pago',
      contactButton: 'Contactar por WhatsApp',
    },

    // Waiting state (no params)
    waiting: {
      title: 'Esperando información',
      message: 'Confirmá tu pago por Mercado Pago.',
      submessage: 'Avisanos por WhatsApp cuando se confirme el pago.',
    },
  },

  // Conecta2 Product Landing Page
  conecta2Product: {
    // SEO & Meta
    meta: {
      title: 'Conecta2 — Juego de mesa cristiano | Fe en Juego',
      description: 'Conecta2: juego de mesa cristiano uruguayo. Ideal para familias, jóvenes e iglesias. Precio lanzamiento y reservas por WhatsApp.',
    },

    // Hero Section
    hero: {
      launchBadge: 'Precio lanzamiento',
      title: '¡Lanzamiento oficial de Conecta2!',
      subtitle: 'Juego de mesa cristiano para familias, jóvenes e iglesias.',
      imageAlt: 'Caja Conecta2 sobre mesa',
    },

    // Price Section
    price: {
      title: 'Precio',
      subtitle: 'Elegí tu método de pago preferido',
      mercadopago: {
        label: 'MercadoPago',
        price: 940,
        detail: 'Hasta 12 cuotas',
      },
      transferencia: {
        label: 'Transferencia / Efectivo',
        price: 850,
        originalPrice: 940,
        discount: '10% OFF',
        detail: 'Pago único',
      },
      selected: 'Seleccionado',
      reserveButton: 'Reservar por WhatsApp',
      paymentInfoLink: 'Consultar métodos de pago y datos de cuenta por WhatsApp',
      whatsappMessage: {
        reserve: `Hola! Quiero reservar Conecta2.
Cantidad: 
Pago: {paymentMethod}
Nombre: 
Dirección (si envío): 
¿Tienen unidades disponibles?`,
        paymentInfo: `Hola! Me gustaría conocer:
• Todos los métodos de pago disponibles
• Datos de cuenta para transferencia
• Información de MercadoPago

¡Gracias!`,
      },
    },

    // What's Included Section
    includes: {
      title: '¿Qué incluye Conecta2?',
      items: [
        'Tablero',
        'Fichas para hasta 10 jugadores',
        'Talonario "Conexión"',
        'Instrucciones',
        'Acceso online a preguntas y desafíos',
      ],
    },

    // How to Play Section
    howToPlay: {
      title: 'Cómo jugar (en 3 pasos)',
      steps: [
        'Elegí tu ficha y ubicala en inicio.',
        'El jugador elige un conectado y resuelven la actividad.',
        'El primero que llegue a la casilla final y resuelva, gana.',
      ],
    },

    // Gallery Section
    gallery: {
      title: 'Galería de fotos',
      images: [
        { alt: 'Juego completo Conecta2' },
        { alt: 'Tablero y caja de Conecta2' },
        { alt: 'App con preguntas y desafíos' },
        { alt: 'Familia jugando Conecta2' },
        { alt: 'Detalle de las fichas del juego' },
        { alt: 'Talonario de conexión' },
        { alt: 'Instrucciones del juego' },
        { alt: 'Jugadores en acción' },
        { alt: 'Componentes del juego' },
      ],
    },

    // FAQ Section
    faq: {
      title: 'Preguntas frecuentes',
      items: [
        {
          question: '¿Cómo pago?',
          answer: 'Coordinamos por WhatsApp. Aceptamos transferencias, efectivo y MercadoPago (hasta 12 cuotas).',
        },
        {
          question: '¿Puedo comprar al por mayor?',
          answer: 'Sí, escribinos por WhatsApp para ver precios por cantidad.',
        },
        {
          question: '¿Hacen envíos?',
          answer: 'Sí, enviamos a todo el país mediante agencias de encomienda.',
        },
        {
          question: '¿Cuánto cuesta el envío?',
          answer: 'El costo depende de la localidad y del método de envío elegido. 💵 El cliente abona el envío al recibir o retirar el paquete.',
        },
        {
          question: '¿Cómo se coordina el envío?',
          answer: 'Luego de confirmar la compra, coordinamos todo por WhatsApp (método de envío, agencia, horarios, etc.) para que te llegue de la forma más rápida y cómoda posible.',
        },
      ],
    },

    // Testimonial Section
    testimonial: {
      title: 'Fe en Juego',
      text: 'Juegos que unen la fe y la familia',
      quote: '"Lámpara es a mis pies tu palabra..." — Salmo 119:105',
    },
  },

  // BibliQuien? — Página del Jugador
  bibliquienGame: {
    hero: {
      title: '¿Cómo se juega a BibliQuien?',
      subtitle: 'Un juego donde cada pregunta te acerca a la respuesta... o te aleja de ella.',
      imageAlt: 'BibliQuien? — Juego bíblico de Fe en Juego',
    },
    badges: {
      physical: 'Juego Físico',
      status: 'Próximamente',
    },
    actions: {
      buy: 'Ver producto',
      instructions: 'REGLAS',
    },
    overview: {
      eyebrow: 'El juego',
      title: 'De un vistazo',
      subtitle: 'Un juego de preguntas, deducción y estrategia para 2 jugadores. Descubrí el personaje bíblico secreto de tu oponente antes de que él descubra el tuyo.',
      facts: [
        { title: 'Jugadores', text: '2' },
        { title: 'Duración', text: '15 min aprox.' },
        { title: 'Contenido', text: '72 cartas · solo cartas' },
      ],
    },
    classic: {
      eyebrow: 'CÓMO JUGAR',
      title: 'Las reglas base de BibliQuién',
      subtitle: 'Todo lo que necesitás saber para jugar.',
      preparation: {
        title: 'Preparación',
        steps: [
          { title: 'Elegí tu mazo', description: 'Cada jugador elige un mazo, azul o amarillo, y coloca todas sus cartas boca arriba frente a él.' },
          { title: 'Elegí el personaje secreto', description: 'Cada jugador elige una carta del mazo bordó sin mostrarla al oponente. Ese será su personaje secreto.' },
        ],
      },
      howToPlay: {
        title: 'Cómo jugar',
        steps: [
          { title: 'Hacé preguntas', description: 'Por turnos, cada jugador hace una pregunta sobre el personaje secreto del oponente. Las preguntas deben poder responderse únicamente con "sí" o "no".' },
          { title: 'Descartá personajes', description: 'Según las respuestas que recibas, descartá de tus cartas boca arriba los personajes que ya no pueden ser el personaje secreto de tu oponente.' },
          { title: '¡Arriesgate!', description: 'Cuando creas saber quién es el personaje secreto, podés intentar adivinarlo en lugar de hacer una pregunta.' },
        ],
      },
      howToWin: {
        title: 'Cómo ganar',
        success: 'Si acertás el personaje secreto → ¡ganás la partida!',
        fail: 'Si te equivocás → perdés la partida.',
        closing: '¿Podrás hacer las preguntas correctas y descubrir al personaje de tu oponente antes de que él descubra el tuyo?',
      },
    },

    modes: {
      eyebrow: 'Modos adicionales',
      title: '¿Listo para jugar diferente?',
      subtitle: 'Mantené las reglas base y agregá desafíos especiales a la partida.',
      items: [
        {
          id: 'desafio-biblico',
          title: 'Desafío Bíblico',
          tagline: '¿Creés saber quién es? Antes de ganar, demostrá cuánto sabés sobre él.',
          rule: {
            title: 'Regla adicional',
            text: 'Cuando intentes adivinar el personaje, debés decir correctamente su nombre y mencionar un hecho o historia bíblica relacionada con él.',
          },
          example: { quote: '“Es Moisés… el que abrió el Mar Rojo.”' },
          outcomes: [
            { status: 'win', text: 'Personaje correcto + dato bíblico correcto → ¡ganás la partida!' },
            { status: 'continue', text: 'Personaje correcto + dato incorrecto → no ganás y la partida continúa.' },
            { status: 'lose', text: 'Personaje incorrecto → perdés la partida.' },
          ],
          closing: 'Este modo agrega un desafío de conocimiento bíblico y ayuda a recordar las historias de la Biblia mientras jugás.',
        },
        {
          id: 'pregunta-prohibida',
          title: 'Pregunta Prohibida',
          tagline: '¿Querés hacer la partida más difícil? Algunas preguntas fáciles quedan prohibidas.',
          rule: {
            title: 'Regla adicional',
            text: 'Durante toda la partida está prohibido preguntar directamente por el género del personaje, su apariencia o vestimenta y el Testamento en el que aparece.',
          },
          forbidden: {
            title: 'No podés preguntar',
            items: ['¿Es hombre?', '¿Tiene barba?', '¿Usa una corona?', '¿Aparece en el Antiguo Testamento?'],
          },
          alternatives: {
            title: 'En cambio, preguntá así',
            items: ['¿Es un rey?', '¿Es un profeta?', '¿Hizo algún milagro?', '¿Tuvo un encuentro con Jesús?', '¿Fue líder del pueblo de Israel?'],
          },
          closing: 'Este modo te obliga a pensar mejor tus preguntas y a usar tus conocimientos bíblicos para encontrar pistas.',
        },
        {
          id: 'batalla-biblica',
          title: 'Batalla Bíblica',
          tagline: '¿Son varios jugadores? Formen equipos y conviertan BibliQuien en una batalla de conocimiento y estrategia.',
          preparation: {
            title: 'Preparación',
            steps: [
              { title: 'Formen dos equipos', description: 'Dividan a los jugadores en dos equipos.' },
              { title: 'Elegí un representante', description: 'Cada equipo elige a un jugador para representarlo durante la ronda.' },
              { title: 'Prepará los secretos', description: 'Los representantes preparan sus personajes secretos como en el modo clásico.' },
            ],
          },
          howToPlay: {
            title: 'Cómo jugar',
            steps: [
              { title: 'Turnos de los representantes', description: 'Los representantes se turnan para hacer preguntas al equipo rival.' },
              { title: 'El equipo opina', description: 'El equipo puede conversar y sugerir preguntas, pero el representante decide finalmente cuál hacer.' },
              { title: 'Intentá adivinar', description: 'Cuando un equipo crea saber cuál es el personaje secreto del rival, puede intentar adivinarlo.' },
            ],
          },
          howToWin: {
            title: 'Cómo ganar',
            success: 'El primer equipo que descubra correctamente el personaje secreto del equipo rival gana la ronda.',
          },
          closing: 'Este modo permite que todos participen, combinando el conocimiento del equipo con la estrategia del representante.',
        },
      ],
    },

    combine: {
      eyebrow: 'Combiná modos',
      title: 'Creá tu propio desafío',
      subtitle: 'Podés combinar los modos como quieras y crear una partida diferente cada vez.',
      examples: [
        { left: 'Desafío Bíblico', right: 'Pregunta Prohibida' },
        { left: 'Batalla Bíblica', right: 'Desafío Bíblico' },
      ],
    },

    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Respondemos las dudas más comunes sobre el juego.',
      items: [
        {
          question: '¿Cuántos jugadores participan?',
          answer: 'BibliQuién? está diseñado para 2 jugadores.',
        },
        {
          question: '¿Qué incluye la caja?',
          answer: 'La caja incluye 72 cartas: los mazos de cada jugador (azul y amarillo) y el mazo de personajes secretos (bordó). No hay tablero ni fichas.',
        },
        {
          question: '¿Cuánto dura una partida?',
          answer: 'Una partida dura aproximadamente 15 minutos.',
        },
        {
          question: '¿Qué pasa si intento adivinar y me equivoco?',
          answer: 'Si un jugador intenta adivinar el personaje secreto y se equivoca, pierde automáticamente la partida.',
        },
      ],
    },
    cta: {
      title: '¿Te interesa BibliQuien?',
      text: 'Próximamente disponible. Consultá por WhatsApp para recibir novedades.',
      buttonText: 'Ver información del producto',
    },
  },

  // BibliQuien? — Página Comercial
  bibliquienProduct: {
    hero: {
      title: 'BibliQuien?',
      subtitle: '¿Podés descubrir qué personaje bíblico tiene tu oponente antes de que él descubra el tuyo? Hacé preguntas, descartá personajes y quedate con el último en pie.',
      imageAlt: 'BibliQuien? — Cartas del juego',
      whatsAppBtn: 'Comprar por WhatsApp',
    },

    badges: {
      type: 'Juego Físico de Cartas',
      status: 'Pre-Venta',
    },

    price: {
      title: 'Conseguí tu BibliQuien?',
      subtitle: 'Un juego rápido y divertido para poner a prueba cuánto sabés de los personajes de la Biblia.',
      statusBadge: 'Precio',
      amountText: '$790',
      amountSubtext: 'MercadoPago $870',
      features: [
        '72 cartas en total',
        '24 personajes bíblicos',
        '2 mazos para jugar: azul y amarillo',
        'Mazo de personajes secretos: bordó',
        'Para 2 jugadores',
      ],
      whatsAppMessage: 'Hola! Me interesa BibliQuién? ¿Cómo puedo comprarlo?',
      whatsAppBtn: 'Comprar por WhatsApp',
      footerNote: 'Coordinamos la compra y el envío por WhatsApp.',
    },

    includes: {
      title: '¿Qué incluye BibliQuien?',
      subtitle: 'Todo lo necesario para jugar y poner a prueba tus habilidades para descubrir personajes bíblicos.',
      item1: '72 cartas en total',
      item2: '24 personajes bíblicos',
      item3: 'Mazos diferenciados por color: azul, amarillo y bordó',
    },

    gallery: {
      title: 'Conocé BibliQuien?',
      subtitle: 'Mirá las cartas y descubrí cómo se ve el juego.',
      item1: 'Mazo azul y mazo amarillo de BibliQuién?',
      item2: 'Dorso de las cartas — azul, amarillo y bordó',
      item3: 'Mazo de personajes y carta de ejemplo',
    },

    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Todo lo que necesitás saber antes de comprar tu BibliQuién?.',
      items: [
        {
          question: '¿Cómo se juega?',
          answer: 'Cada jugador recibe un personaje bíblico secreto. Por turnos, hacen preguntas para ir descartando personajes hasta descubrir cuál tiene su oponente. ¡El primero en descubrirlo, gana!',
        },
        {
          question: '¿Para cuántos jugadores es?',
          answer: 'BibliQuién? está pensado para 2 jugadores.',
        },
        {
          question: '¿Qué personajes aparecen en el juego?',
          answer: 'El juego incluye 24 personajes bíblicos diferentes, seleccionados para que puedas poner a prueba cuánto recordás de la Biblia.',
        },
        {
          question: '¿Qué incluye la caja?',
          answer: 'La caja incluye las 72 cartas del juego: el mazo azul, el mazo amarillo y el mazo de personajes secretos (bordó). No incluye tablero ni fichas.',
        },
        {
          question: '¿Hacen envíos?',
          answer: 'Sí, hacemos envíos a todo el país. Coordinamos los detalles del envío al momento de realizar la compra.',
        },
      ],
    },
  },

  // Logo YA! — Página del Jugador
  logoYaGame: {
    hero: {
      title: 'Logo YA!',
      subtitle: 'Identifica rápidamente símbolos y conceptos de la fe en un emocionante juego de velocidad mental.',
      imageAlt: 'Logo YA! — Juego de velocidad visual de Fe en Juego',
    },
    badges: {
      physical: 'Juego Físico',
      status: 'Próximamente',
    },
    actions: {
      buy: 'Ver producto',
      instructions: 'Cómo se juega',
    },
    overview: {
      title: 'Sobre Logo YA!',
      subtitle: '[PLACEHOLDER] Descripción general del juego pendiente de definición.',
      cards: {
        conceptTitle: 'Concepto',
        conceptText: '[PLACEHOLDER] Un juego de agilidad visual e identificación de símbolos.',
        playersTitle: 'Jugadores',
        playersText: '[PLACEHOLDER] 2 a 8 jugadores.',
        durationTitle: 'Duración',
        durationText: '[PLACEHOLDER] 20 a 45 minutos por partida.',
      },
    },
    instructions: {
      title: 'Cómo se juega',
      subtitle: '[PLACEHOLDER] Las instrucciones definitivas están en proceso.',
      steps: [
        { title: 'Preparación', description: '[PLACEHOLDER] Descripción de cómo preparar el juego antes de comenzar.' },
        { title: 'Desarrollo', description: '[PLACEHOLDER] Descripción de cómo transcurre la partida.' },
        { title: 'Cómo ganar', description: '[PLACEHOLDER] Condición de victoria pendiente de definir.' },
      ],
    },
    modes: {
      title: 'Modos de juego',
      subtitle: '[PLACEHOLDER] Los modos de juego definitivos están en proceso de definición.',
      items: [
        { title: 'Modo Clásico', description: '[PLACEHOLDER] Descripción del modo clásico.' },
        { title: 'Modo Cronometrado', description: '[PLACEHOLDER] Descripción del modo contrarreloj.' },
        { title: 'Modo Equipos', description: '[PLACEHOLDER] Descripción del modo por equipos.' },
      ],
    },
    expansions: {
      title: 'Recursos y expansiones',
      subtitle: '[PLACEHOLDER] Materiales adicionales y expansiones futuras.',
      downloadsTitle: 'Hojas imprimibles',
      downloadsText: '[PLACEHOLDER] Próximamente disponibles para descargar.',
      futureTitle: 'Expansiones futuras',
      futureText: '[PLACEHOLDER] Nuevas categorías de logos y símbolos en desarrollo.',
    },
    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Respondemos las dudas más comunes sobre el juego.',
      items: [
        { question: '¿Para qué edades está pensado?', answer: '[PLACEHOLDER] Rango de edades pendiente de definición.' },
        { question: '¿Cuántos jugadores pueden participar?', answer: '[PLACEHOLDER] Número de jugadores pendiente de definición.' },
        { question: '¿Es difícil aprender a jugar?', answer: '[PLACEHOLDER] Nivel de dificultad y curva de aprendizaje pendientes.' },
      ],
    },
    cta: {
      title: '¿Te interesa Logo YA!?',
      text: 'Próximamente disponible. Consultá por WhatsApp para recibir novedades.',
      buttonText: 'Ver información del producto',
    },
  },

  // Logo YA! — Página Comercial
  logoYaProduct: {
    hero: {
      title: 'Logo YA! — El juego',
      subtitle: '[PLACEHOLDER] Descripción comercial del producto pendiente de definición.',
      imageAlt: 'Logo YA! — Caja del juego',
      whatsAppBtn: 'Consultar por WhatsApp',
    },
    badges: {
      type: 'Juego de Mesa',
      status: 'Próximamente',
    },
    price: {
      title: 'Reservá tu Logo YA!',
      subtitle: 'Próximamente disponible. Podés consultar o reservar tu unidad ahora.',
      statusBadge: 'Próximamente',
      amountText: 'Precio próximamente',
      amountSubtext: 'El precio definitivo será confirmado al lanzamiento.',
      features: [
        'Juego de mesa físico completo',
        'Instrucciones incluidas',
        'Envíos a todo el país',
        'Atención por WhatsApp',
      ],
      whatsAppMessage: 'Hola! Me interesa Logo YA! ¿Cuándo estará disponible?',
      whatsAppBtn: 'Consultar por WhatsApp',
      footerNote: 'Sin compromiso de compra. Coordinamos todo por WhatsApp.',
    },
    includes: {
      title: '¿Qué incluye Logo YA!?',
      subtitle: '[PLACEHOLDER] Contenido definitivo de la caja pendiente de definición.',
      item1: '[PLACEHOLDER] Componente 1',
      item2: '[PLACEHOLDER] Componente 2',
      item3: '[PLACEHOLDER] Componente 3',
      item4: '[PLACEHOLDER] Componente 4',
    },
    gallery: {
      title: 'Galería',
      subtitle: '[PLACEHOLDER] Fotos del producto próximamente.',
      item1: '[PLACEHOLDER] Vista del juego completo',
      item2: '[PLACEHOLDER] Detalle de los logos',
      item3: '[PLACEHOLDER] Caja del juego',
    },
    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Respondemos las dudas más comunes sobre la compra.',
      items: [
        { question: '¿Cuándo estará disponible?', answer: '[PLACEHOLDER] Fecha de lanzamiento pendiente de definición.' },
        { question: '¿Cómo puedo reservar mi unidad?', answer: 'Consultá por WhatsApp y te informamos del proceso.' },
        { question: '¿Hacen envíos?', answer: 'Sí, enviamos a todo el país mediante agencias de encomienda.' },
      ],
    },
  },
};

export default es;
